/**
 * HowItWorks Schema
 * Schema-driven settings for step-by-step process section
 */
export default {
  id: 'howitworks',
  version: 1,
  title: 'Как это работает',
  description: 'Блок с пошаговым описанием процесса',
  icon: 'ListOrdered',
  category: 'content',

  fields: [
    {
      group: 'Контент',
      fields: [
        {
          key: 'title',
          type: 'text',
          label: 'Заголовок',
          placeholder: 'Как это работает',
          defaults: { size: '3xl', weight: 'bold', color: 'foreground' }
        },
        {
          key: 'subtitle',
          type: 'text',
          label: 'Подзаголовок',
          placeholder: 'Простой процесс',
          defaults: { size: 'lg', weight: 'normal', color: 'secondary' }
        }
      ]
    },
    {
      group: 'Оформление',
      fields: [
        {
          key: 'style',
          type: 'select',
          label: 'Стиль',
          mode: 'grid',
          columns: 3,
          options: [
            { value: 'numbered', label: 'Номера', icon: 'Hash' },
            { value: 'icons', label: 'Иконки', icon: 'Star' },
            { value: 'timeline', label: 'Таймлайн', icon: 'GitBranch' }
          ]
        }
      ]
    },
    {
      group: 'Шаги',
      fields: [
        {
          key: 'steps',
          type: 'list',
          label: 'Шаги',
          addLabel: 'Добавить',
          itemLabel: 'Шаг',
          itemFields: [
            {
              key: 'icon',
              type: 'icon',
              label: 'Иконка',
              default: 'Star'
            },
            {
              key: 'title',
              type: 'text',
              label: 'Заголовок',
              placeholder: 'Заголовок шага',
              defaults: { size: 'xl', weight: 'semibold', color: 'foreground' }
            },
            {
              key: 'description',
              type: 'text',
              label: 'Описание',
              placeholder: 'Описание шага',
              multiline: true,
              rows: 2,
              defaults: { size: 'base', weight: 'normal', color: 'secondary' }
            }
          ]
        }
      ]
    }
  ],

  default: {
    title: { text: 'Как это работает' },
    subtitle: { text: 'Простой процесс в несколько шагов' },
    style: 'numbered',
    steps: [
      { id: '1', icon: 'Search', title: { text: 'Выберите помещение' }, description: { text: 'Просмотрите каталог и выберите подходящий вариант' } },
      { id: '2', icon: 'Calendar', title: { text: 'Забронируйте время' }, description: { text: 'Укажите дату и время для бронирования' } },
      { id: '3', icon: 'CreditCard', title: { text: 'Оплатите онлайн' }, description: { text: 'Безопасная оплата любым удобным способом' } },
      { id: '4', icon: 'CheckCircle', title: { text: 'Получите подтверждение' }, description: { text: 'Мгновенное подтверждение на вашу почту' } }
    ]
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      const migrated = { ...this.default, ...data };
      ['title', 'subtitle'].forEach(key => {
        if (typeof migrated[key] === 'string') {
          migrated[key] = { text: migrated[key] };
        }
      });
      if (migrated.steps) {
        migrated.steps = migrated.steps.map(step => ({
          ...step,
          id: step.id || Date.now().toString(),
          title: typeof step.title === 'string' ? { text: step.title } : (step.title || { text: '' }),
          description: typeof step.description === 'string' ? { text: step.description } : (step.description || { text: '' })
        }));
      }
      return migrated;
    }
    return data;
  }
};
